import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Store } from '@ngxs/store';
import { AddToUserQueue } from 'app/store/queue/queue.actions';
import { MatMenuTrigger } from '@angular/material/menu';
import { UntypedFormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-add-to-queue-dropdown',
  templateUrl: './add-to-queue-dropdown.component.html',
  styleUrls: ['./add-to-queue-dropdown.component.scss'],
  standalone: false
})
export class AddToQueueDropdownComponent implements OnInit {

  @ViewChild(MatMenuTrigger, { static: true }) trigger: MatMenuTrigger;
  @ViewChild('focus', { static: true }) focusInput: ElementRef;

  form: UntypedFormGroup;
  processing = false;
  total = 0;
  completed = 0;

  constructor(
    private store: Store,
    private formBuilder: UntypedFormBuilder
  ) {
    this.form = this.formBuilder.group({
      borrowerIds: [
        '',
        Validators.compose([Validators.required, Validators.pattern('^[0-9\n]+$')])
      ]
    });
  }

  ngOnInit() {
  }

  get borrowerIds() {
    return this.form.get('borrowerIds');
  }

  async handleSubmit($event) {
    $event.stopPropagation();
    if (this.form.invalid) {
      return;
    }

    // setup
    this.processing = true;
    const borrowerIds = this.parseValue();
    this.total = borrowerIds.length;

    // processing
    await Promise.all(borrowerIds.map(async (borrowerId) => lastValueFrom(this.store.dispatch(new AddToUserQueue(borrowerId)))
        .catch(() => {
          this.completed++;
        })
        .then(() => this.completed++)));

    // cleanup
    this.reset();
    this.trigger.closeMenu();
  }

  reset() {
    this.form.reset();
    this.completed = 0;
    this.total = 0;
    this.processing = false;
  }

  parseValue(): number[] {
    return this.form.value.borrowerIds
      .trim()
      .split('\n')
      .map(x => x.trim())
      .filter(x => /^\d+$/.test(x))
      .map(x => parseInt(x));
  }

  handleOpened() {
    setTimeout(() => {
      this.focusInput.nativeElement.focus();
    }, 0);
  }

  handleClosed() {
    if (this.form.value.borowerIds && this.form.value.borowerIds.length) {
      return;
    }
    this.form.reset();
  }
}
